import { captureException } from '@sentry/nextjs';
import tweetnacl from 'tweetnacl';
import * as tweetNaclUtil from 'tweetnacl-util';

export const encrypt = (
  message: string,
  key: Uint8Array,
  nonce: Uint8Array
): string => {
  const messageUint8 = tweetNaclUtil.decodeUTF8(message);
  return tweetNaclUtil.encodeBase64(
    tweetnacl.secretbox(messageUint8, nonce, key)
  );
};

export const decrypt = (
  ciphertextBase64: string,
  key: Uint8Array,
  nonce: Uint8Array
): string => {
  const ciphertext = tweetNaclUtil.decodeBase64(ciphertextBase64);
  const decrypted = tweetnacl.secretbox.open(ciphertext, nonce, key);
  if (!decrypted) {
    captureException('failed to decrypt update');
    throw new Error('failed to decrypt update');
  }
  return tweetNaclUtil.encodeUTF8(decrypted);
};
export const generateDocWsKey = () => {
  const key = tweetNaclUtil.encodeBase64(
    tweetnacl.randomBytes(tweetnacl.secretbox.keyLength)
  );
  return key;
};
